import React from "react";
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';

const SearchIcon = (props)=>{
    return (
        <div style={{textAlign:'center', marginTop:'18px', width:'100%'}}>
            <SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
                onClick={(e)=>props.actionSearch(e)}/>
        </div>
    )
}

export default SearchIcon;